module.exports = __webpack_public_path__ + "media/src/images/icons/reward/timer-07fbe0baa9f8171566213c0a1d6dec68.svg";